import { combineReducers } from 'redux'

import approvalCard from 'containers/Manage/NvqualSubmissions/ApprovalCard/reducer'

export default combineReducers({
    approvalCard
})
  